import { NgModule } from '@angular/core';
import { TranslationModule } from 'angular-l10n';
const sharedModules: any[] = [
    TranslationModule
];

@NgModule({
    imports: sharedModules,
    exports: sharedModules
})

export class TranslationSharedModule { }
